export const blockIconsTextformattingDragHandleNew = (
	<span className='material-symbols-outlined'>drag_handle</span>
);
